// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"41":"e86062bd","494":"a034b1c2","695":"068dd231"}[chunkId] + ".css";
};